/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_HInputs */

const en_funnel_pw_h = /** @type {(inputs: Funnel_Pw_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start listening today. Cancel anytime.`)
};

const es_funnel_pw_h = /** @type {(inputs: Funnel_Pw_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a escuchar hoy. Cancela cuando quieras.`)
};

/**
* | output |
* | --- |
* | "Start listening today. Cancel anytime." |
*
* @param {Funnel_Pw_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_h = /** @type {((inputs?: Funnel_Pw_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_h(inputs)
	return en_funnel_pw_h(inputs)
});